import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { MenuItem, TextField } from '@mui/material';

// Switching application navigates rather than setting state: the application is
// a route segment, so the list stays linkable and the back button works.
const ApplicationSelect = (props) => {
  const { application, applications } = props;
  const navigate = useNavigate();

  const known = applications.some((app) => app.code === application);

  return (
    <TextField
      select
      size="small"
      label="Application"
      sx={{ minWidth: 200 }}
      value={known ? application : ''}
      onChange={(event) => navigate(`/packages/${event.target.value}`)}
    >
      {!known && (
        <MenuItem value="" disabled>
          {application || 'Select an application'}
        </MenuItem>
      )}
      {applications.map((app) => (
        <MenuItem key={app.uuid || app.code} value={app.code}>
          {app.name || app.code}
        </MenuItem>
      ))}
    </TextField>
  );
};

ApplicationSelect.propTypes = {
  application: PropTypes.string,
  applications: PropTypes.array.isRequired,
};

export default ApplicationSelect;
